export const environment = {
  production: false,
  apiUrl: 'https://apidev.fullfillspace.ru/v1',
  imgUrlStorage: 'https://apidev.fullfillspace.ru/storage/',
  webSocket: 'wss://wsdev.fullfillspace.ru'
};
